import { Link } from 'react-router-dom'
import MediaImage from './MediaImage'
import SectionHead from './SectionHead'
import StoryRow from './StoryRow'
import { homeCategory, type Story } from '../data/content'
import { storyPath } from '../lib/paths'

type Props = {
  name: string
  href: string
  imageStory: Story
  leadStory: Story
  listStories: Story[]
}

export default function CategorySpotlight({ name, href, imageStory, leadStory, listStories }: Props) {
  const isLook = homeCategory(imageStory) === 'Look Books'

  return (
    <div className="min-w-0">
      <SectionHead title={name} aside="See all" href={href} compact />
      <Link to={storyPath(imageStory.slug)} aria-label={imageStory.title} className="group block">
        <div className={`overflow-hidden aspect-[4/5] ${isLook ? 'bg-white' : 'bg-sand'}`}>
          <MediaImage
            src={imageStory.image}
            size="card"
            alt={imageStory.title}
            className={`h-full w-full ${isLook ? 'object-contain object-top' : 'object-cover object-top'}`}
          />
        </div>
      </Link>
      <Link to={storyPath(leadStory.slug)} className="group mt-3 block border-b border-ink pb-4">
        <p className="text-caps text-rose">{leadStory.category}</p>
        <h3 className="text-caps-h3 mt-2 text-ink group-hover:text-rose">{leadStory.title}</h3>
        <p className="mt-2 leading-relaxed text-muted">{leadStory.dek}</p>
      </Link>
      <div>
        {listStories.map((story) => (
          <StoryRow key={story.slug} story={story} compact />
        ))}
      </div>
    </div>
  )
}
